import { render, staticRenderFns } from "./goodDetail.vue?vue&type=template&id=37e0f02f&scoped=true"
import script from "./goodDetail.vue?vue&type=script&lang=js"
export * from "./goodDetail.vue?vue&type=script&lang=js"
import style0 from "./goodDetail.vue?vue&type=style&index=0&id=37e0f02f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e0f02f",
  null
  
)

export default component.exports